/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SignerFromExistingContactCreateV1Dto } from './SignerFromExistingContactCreateV1Dto';
import type { SignerFromExistingUserCreateV1Dto } from './SignerFromExistingUserCreateV1Dto';
import type { SignerFromScratchCreateV1Dto } from './SignerFromScratchCreateV1Dto';
export type CreateSignerPayloadV1Dto = {
  /**
   * The data of the signer to create
   */
  data:
    | SignerFromScratchCreateV1Dto
    | SignerFromExistingUserCreateV1Dto
    | SignerFromExistingContactCreateV1Dto;
  /**
   * The type of signer to create
   */
  type: CreateSignerPayloadV1Dto.type;
};
export namespace CreateSignerPayloadV1Dto {
  /**
   * The type of signer to create
   */
  export enum type {
    FROM_EXISTING_CONTACT = 'from_existing_contact',
    FROM_EXISTING_USER = 'from_existing_user',
    FROM_SCRATCH = 'from_scratch',
  }
}
